import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c46a4410"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-expanded", "aria-haspopup", "aria-controls", "aria-labelledby"]
const _hoisted_2 = ["id", "placeholder", "value", "disabled"]
const _hoisted_3 = ["aria-label"]

import { Icon } from '../../Atoms';


export default /*#__PURE__*/_defineComponent({
  __name: 'Searchbox',
  props: {
    id: {},
    placeholder: {},
    value: {},
    disabled: { type: Boolean },
    ariaExpanded: { type: Boolean },
    ariaHasPopup: { type: Boolean },
    ariaLabeledBy: {},
    ariaControls: {},
    hideSearchBtn: { type: Boolean },
    error: { type: Boolean }
  },
  emits: ['update', 'searchClick', 'setIsFocus'],
  setup(__props: any) {

const props = __props;


const handleClick = () => {
  if (props.disabled) {
    return;
  }
  emit('searchClick');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["search-container", { disabled: _ctx.disabled, error: (_ctx.error ? 'error': '') }]),
    role: "combobox",
    "aria-expanded": _ctx.ariaExpanded,
    "aria-haspopup": _ctx.ariaHasPopup,
    "aria-controls": _ctx.ariaControls,
    "aria-labelledby": _ctx.ariaLabeledBy
  }, [
    _createElementVNode("input", {
      id: _ctx.id,
      placeholder: _ctx.placeholder,
      autocomplete: "off",
      type: "search",
      value: _ctx.value,
      disabled: _ctx.disabled,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update', $event.target.value))),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('searchClick')), ["enter"])),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('setIsFocus', true))),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('setIsFocus', false)))
    }, null, 40, _hoisted_2),
    (_ctx.hideSearchBtn)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["searchBtn", { disabled: _ctx.disabled }]),
          "aria-label": _ctx.$t('Search button aria label'),
          onClick: handleClick
        }, [
          _createVNode(_unref(Icon), { "icon-name": "search" })
        ], 10, _hoisted_3))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})